module.exports = __webpack_public_path__ + "static/media/logo.af0ea16c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 462
// module chunks = 0